import { Box, Typography } from "@mui/material";
import { useEffect } from "react";

import { shootConfetti } from "@/components/sharedComponents/confetti";
import { useUpdateDataContext } from "@/contexts/UpdateDataContext";

export default function Confirmation() {
  const { politicalData } = useUpdateDataContext();

  useEffect(() => {
    shootConfetti();
  }, []);

  return (
    <Box
      sx={{
        margin: "80px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography sx={{ marginBottom: "20px" }}>Yay you did it!</Typography>
      <Typography sx={{ fontSize: "1.2rem" }}>
        {politicalData.fileName} has been submitted.
      </Typography>
    </Box>
  );
}
